/* eslint-disable object-property-newline */
import React from "react";
import "./TradingPull.scss";

export default function TradingPull() {
  return (
    <>
      <div className="container-iframe" style={{ marginTop: "80px" }}>
        <iframe className="responsive-iframe" src="https://v2.tradingbull.ai/?token=26|PPOatB5dQguAylX9UT7SqRpDNc6GwrZEnyVZIjiE770e180a&widget_id=5543804"></iframe>
      </div>
    </>
  );
}